import React from 'react'
import BlogNav from '../../components/BlogNav';
import CategoryPosts from './CategoryPosts';

export default function BlogCategory(props) {
     return (
        <div>
        <section className="blog-section ptb-200">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="row"> 
                        <CategoryPosts {...props}/>                           
                        </div>
                    </div>
                   <BlogNav/>
                </div>
            </div>
        </section>
        </div>
    )
}
